import React from 'react';
import { country } from '../../../utils/current-site';
import { MAX_DISTANCE } from './constants';

const OtherCountry = () => {
  if (country === 'England') {
    return (
      <a href="https://scotland.shelter.org.uk/get_advice">Shelter Scotland</a>
    );
  }
  return <a href="https://england.shelter.org.uk/get_help">Shelter England</a>;
};

export const OutOfBoundsMsg = () =>
  country === 'England' ? (
    <div data-testid="out-of-bounds">
      <p>
        {`Unfortunately, our closest service is over ${MAX_DISTANCE} miles away
    from you – but you can visit our `}
        <a href="https://england.shelter.org.uk/get_help">Get help</a> section,
        or{' '}
        <a href="https://england.shelter.org.uk/housing_advice">
          housing advice pages
        </a>{' '}
        for help
      </p>
      <p>
        If you need advice about something other than housing, search our list
        of{' '}
        <a href="https://england.shelter.org.uk/housing_advice/other_services">
          local advice organisations and services.
        </a>
      </p>
    </div>
  ) : (
    <div data-testid="out-of-bounds">
      <p>
        {`Unfortunately, our closest service is over ${MAX_DISTANCE} miles away
    from you – but you can visit our `}{' '}
        <a href="https://scotland.shelter.org.uk/housing_advice">
          housing advice pages
        </a>{' '}
        for help
      </p>
    </div>
  );

export const InvalidCountryMessage = () => (
  <div data-testid="wrong-country">
    <p>
      Unfortunately, we can only show local advice services for people living in{' '}
      {country}.
    </p>

    <p>
      But you can visit <OtherCountry />,{' '}
      <a href="https://sheltercymru.org.uk/get-advice/advice-near-you/">
        Shelter Cymru
      </a>{' '}
      or{' '}
      <a href="https://www.housingadviceni.org/speak-adviser">
        Housing Advice Northern Ireland
      </a>{' '}
      for help in other parts of the United Kingdom.
    </p>
  </div>
);

export const NoResultsFound = () => (
  <div data-testid="no-results-found">
    <p>
      Sorry, we couldn't find any results based on your search, please try again
    </p>
  </div>
);
